import { RemoteChangeUserDetails } from "../../../../data/usecases/change-user-details/remote-create-details";
import { ChangeUserDetails } from "../../../../domain/usecases";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteChangeUserDetails = (): ChangeUserDetails =>
  new RemoteChangeUserDetails(
    makeApiUrl("/users/change-user-details"),
    makeAxiosHttpClient()
  );
